import conciliacaoProjetoServico from './servico';

export const DESTINO_LANCAMENTO = 'lancamento';
export const DESTINO_CONTA_RECEBER = 'conta-receber';
export const DESTINO_SOLICITACAO = 'solicitacao-transferencia';

export default {
  data() {
    return {
      anexoConfig: {
        lancamento: false,
        contaReceber: false,
        solicitacaoTransferencia: false,
        extratoConta: false,
        limiteArquivo: 0,
      },
    }
  },
  computed: {
    limiteAnexo() { return +this.anexoConfig.limiteArquivo || 0; },
    podeAnexarLancamento() { return !!this.anexoConfig.lancamento; },
    podeAnexarContaReceber() { return !!this.anexoConfig.contaReceber; },
    podeAnexarSolicitacao() { return !!this.anexoConfig.solicitacaoTransferencia; },
  },
  methods: {
    carregarConfigAnexos() {
      conciliacaoProjetoServico.configuracaoAnexos()
        .then(dados => { if (dados) this.anexoConfig = dados; })
        .catch(() => {});
    },
    origensAnexo(dados) {
      const d = dados || {};
      const extrato = !!this.anexoConfig.extratoConta && (+d.idExtrato > 0 || +d.idLancamento > 0);
      const contas = !!d.comContasReceber && !!this.anexoConfig.contaReceber;
      const busca = !!this.anexoConfig.contaReceber;
      const idsContaReceber = busca ? (d.idsContaReceber || []).filter(id => +id > 0) : [];
      const outrosExtratos = !!this.anexoConfig.extratoConta;

      if (!extrato && !contas && !busca && !outrosExtratos) return null;

      return {
        idExtrato: extrato ? +d.idExtrato || 0 : 0,
        idLancamento: extrato ? +d.idLancamento || 0 : 0,
        comContasReceber: contas,
        comBuscaContasReceber: busca,
        comOutrosExtratos: outrosExtratos,
        idPessoa: +d.idPessoa || 0,
        nomePessoa: d.nomePessoa || '',
        idsContaReceber,
        idContaSugerida: outrosExtratos ? +d.idContaSugerida || 0 : 0,
        nomeContaSugerida: outrosExtratos ? d.nomeContaSugerida || '' : '',
      };
    },
    enviarAnexos(envios) {
      const validos = (envios || []).filter(e =>
        e && e.arquivos && e.arquivos.length > 0 && (e.ids || []).some(i => +i > 0));

      if (validos.length === 0) return Promise.resolve();

      return validos.reduce((fila, envio) => fila.then(() =>
        conciliacaoProjetoServico.enviarAnexos(envio.destino, envio.ids, envio.arquivos)
          .catch(res => {
            const detalhe = res && res.body && res.body.message ? ' ' + res.body.message : '';

            toastr.warning('A operação foi gravada, mas não foi possível anexar '
              + (envio.arquivos.length > 1 ? 'os arquivos' : 'o arquivo') + ' de ' + (envio.rotulo || 'anexos') + '.'
              + detalhe);
          })
      ), Promise.resolve());
    },
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/conciliacao-projeto/anexos.js